import { render } from "./GeneralStatsCards.vue?vue&type=template&id=700a8ae2&ts=true"
import script from "./GeneralStatsCards.vue?vue&type=script&lang=ts"
export * from "./GeneralStatsCards.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__